<template>
<div>
    <base-header v-once pageName="프로필 상세" :popup="true"></base-header>
	<section id="wrap">
		<div class="profile">
			<p>
				<em :class="userInfo.gubun | jicClass"></em>
				<strong>{{userInfo.akdnam}}</strong>
				<span>{{userInfo.akdcde}}</span>
				<!-- 명함관리 바로가기 버튼 추가 -->
               <button type="button" class="profile-view" v-if="this.$store.state.session.userName == userInfo.akdnam" @click="goKssSite(true,'kss','/pioneer/callingCardMk')">명함관리 바로가기</button>
			</p>
			<dl>
				<dt>총괄단</dt>
				<dd>{{userInfo.gnrlName}}</dd>
				<dt>센터</dt>
				<dd>{{userInfo.cntrName}}</dd>
				<dt>소속코드</dt>
				<dd>{{userInfo.akddpt}}</dd>
				<dt>업무등록일</dt>
				<dd>{{userInfo.akden | toDate}}</dd>
				<dt>등록기준일</dt>
				<dd>{{userInfo.akdst | toDate}}</dd>
				<dt>차월</dt>
				<dd>{{userInfo.chawol}}차월</dd>
				<dt>형태</dt>
				<dd>{{userInfo.akdje == "00000000" ? "신규":"복직"}}</dd>
			</dl>
		</div>
	</section>
</div>
</template>

<script>
export default {
	name: "OrgnzProfile",
	data() {
		return{
			userInfo:{
				akdcde : this.$route.query.targetId,
				gubun : this.$route.query.gubun,
				akdnam : this.$route.query.akdnam
			}
		};
	},
	methods: {
		showSMS:function(telNo){
			alert("문자발송 템플릿 화면 이동. (hono = "+telNo)
		},
		goKssSite(ssoYn, type, url){
			if(ssoYn){
				if(type == 'kss'){
					this.$utils.external.kss(url);
				}else {
					alert("잘못된 요청입니다.")
					return false;                
				}
			}else{
				this.$utils.nativeIf.outbound.outlink(url)
			}
		}
	},
	created: function() {
		var that = this
		var parameters = {
			'targetId': this.$route.query.targetId
		};
		this.$api.orgnz
		.profile(parameters)
		.then(function(data) {
			if(data){
				that.userInfo = data;
			}
		})
		.catch(function(error) {
			alert(error.rtMsg);
		});
	},
	filters:{
		numFormat:function(num){
			if(num==0) return 0;

			var n = num+'';
			var reg = /(^[+-]?\d+)(\d{3})/;
			
			while (reg.test(n))
			n = n.replace(reg,'$1'+','+'$2');
			
			return n;
		},
		toDate:function(date){
			if(!date) return date;

			var fmtDate = date;
			if(date.length == 8){
				fmtDate = date.substring(0,4) + ".";
				fmtDate += date.substring(4,6) + ".";
				fmtDate += date.substring(6,8);
			}else if(date.length == 6){
				if(date.substring(0,2) < 50){
					fmtDate =20;
				}else{
					fmtDate =19;
				}
				fmtDate += date.substring(0,2) + ".";
				fmtDate += date.substring(2,4) + ".";
				fmtDate += date.substring(4,6);
			}
			
			return fmtDate;
		},
		jicClass:function(gubun){
			var clss = "";
			
			if(gubun == 'COG01'){
				clss = "epLv";
			}else if(gubun == 'COG02'){ 
				clss = "epLv1";
			}else if(gubun == 'COGA2'){ 
				clss = "epLvA1";
			}else if(gubun == 'COG03'){ 
				clss = "epLv2";
			}else if(gubun == 'COG04'){
				clss = "epLv3";
			}else if(gubun == 'COG05'){
				clss = "epLv4";
			}else if(gubun == 'COG06'){
				clss = "epLv5";
			}

			return clss;
		}
	}
};
</script>
